const messages = {
  "Client updated": "已更新客户端",
  "Copied To Clipboard": "已复制",
  "Token Copied To Clipboard": "已复制权限密钥",
  "Token successfully created": "已创建权限密钥",
  "Server successfully created": "已创建服务器",
  "Snapshot successfully restored": "已恢复备份",
  "invalid loginname or password": "账号或密码错误",
  "invalid password": "密码错误",
  "insufficient client permissions": "权限不足",
  "insufficient group modify power": "无权修改身份组",
  "insufficient permission modify power": "无权修改此权限",
  "database empty result set": "暂无数据",
  "invalid clientID": "客户端不存在或已离线",
  "invalid channelID": "频道不存在",
  "invalid serverID": "服务器不存在",
  "invalid group ID": "身份组不存在",
  "invalid parameter": "参数无效",
  "invalid parameter size": "参数长度无效",
  "invalid parameter count": "参数数量无效",
  "parameter not found": "缺少参数",
  "not connected": "尚未连接",
  "not logged in": "尚未登录",
  "server is not running": "服务器未运行",
  "server is virtual": "服务器未启动",
  "channel maxclient reached": "频道已满",
  "max clients protocol limit reached": "服务器人数已达上限",
  "channel name is already in use": "频道名已存在",
  "channel not empty": "频道非空",
  "file not found": "文件不存在",
  "file input/output error": "文件读写失败",
  "database duplicate entry": "记录已存在",
  "missing required parameter": "缺少必填参数",
  "connection lost": "连接已断开",
  "connection closed": "连接已关闭",
  "Connection closed": "连接已关闭",
  "Connection timed out": "连接超时",
  "Disconnected": "连接已断开",
  "Invalid token": "登录已失效，请重新登录",
  "jwt expired": "登录已过期，请重新登录",
  "invalid signature": "登录凭证无效",
  "Missing servername": "缺少服务器地址",
  "No valid port number": "端口无效",
  "Unsupported protocol": "不支持此协议",
  "TeamSpeak server is not whitelisted": "服务器不在允许列表中",
};

export function localizeToast(value, type = "info") {
  const message = typeof value === "string" ? value : value && value.message;
  const raw = message || (type === "error" ? "操作失败" : "操作完成");
  let text = messages[raw];
  if (!text && /ECONNREFUSED/i.test(raw)) text = "连接被拒绝";
  if (!text && /ETIMEDOUT|timeout|timed out/i.test(raw)) text = "连接超时";
  if (!text && /ECONNRESET|socket hang up/i.test(raw)) text = "连接已断开";
  if (!text && /ENOTFOUND|EAI_AGAIN/i.test(raw)) text = "无法解析服务器地址";
  if (!text && /flooding|flood ban/i.test(raw)) text = "请求过于频繁，请稍后重试";
  if (!text && /^insufficient client permissions/i.test(raw)) text = "权限不足：" + raw;
  if (!text) text = /[\u3400-\u9fff]/.test(raw) ? raw : (type === "error" ? "操作失败：" : "提示：") + raw;
  const details = [];
  if (value && typeof value === "object") {
    if (value.id !== undefined) details.push("错误码：" + value.id);
    const permission = value.failed_permid === undefined ? value.failedPermid : value.failed_permid;
    if (permission !== undefined) details.push("权限 ID：" + permission);
  }
  if (details.length) text += "（" + details.join("；") + "）";
  // The toast component renders HTML; all server-provided text must remain plain text.
  return text.replace(/[&<>"']/g, character => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character]));
}

export function installChineseToast(api) {
  const open = api.open;
  api.open = function(options) {
    const settings = typeof options === "string" ? { message: options } : options;
    return open.call(this, { ...settings, message: localizeToast(settings.message, settings.type) });
  };
}
